export const mathlist = [
  {
    value: "",
    latexCode: "x^2",
    icon: "/img/math-editors/math-editor1.svg"
  },
  {
    value: "",
    latexCode: "\\frac{a}{b}",
    icon: "/img/math-editors/math-editor2.svg"
  },
  {
    value: "",
    latexCode: "\\sqrt{x}",
    icon: "/img/math-editors/math-editor3.svg"
  },
  {
    value: "",
    latexCode: "\\sqrt[3]{x}",
    icon: "/img/math-editors/math-editor4.svg"
  },
  {
    value: "",
    latexCode: "x_n",
    icon: "/img/math-editors/math-editor5.svg"
  },
  {
    value: "",
    latexCode: "\\lbrace\\frac a b\\rbrace",
    icon: "/img/math-editors/math-editor6.svg"
  },
  {
    value: "",
    latexCode: "\\sqrt{\\frac{a}{b}}",
    icon: "/img/math-editors/math-editor7.svg"
  }
];

export const symbolList = [
  {
    value: "",
    latexCode: "x^2",
    icon: "/img/math-editors/math-editor1.svg"
  },
  {
    value: "",
    latexCode: "\\frac a b",
    icon: "/img/math-editors/math-editor2.svg"
  },
  {
    value: "",
    latexCode: "\\sqrt{x}",
    icon: "/img/math-editors/math-editor3.svg"
  },
  {
    value: "",
    latexCode: "\\sqrt[3]{x}",
    icon: "/img/math-editors/math-editor4.svg"
  },
  {
    value: "",
    latexCode: "x_n",
    icon: "/img/math-editors/math-editor5.svg"
  },
  {
    value: "",
    latexCode: "\\lbrace\\frac a b\\rbrace",
    icon: "/img/math-editors/math-editor6.svg"
  },
  {
    value: "",
    latexCode: "\\sqrt{\\frac a b}",
    icon: "/img/math-editors/math-editor7.svg"
  }
];
